<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-dollar-sign"></i></span>{{ 'Menu.Menu.InOutWarehousingFormQuery' | translate }}
  </h1>
  <p-card>
    <p-accordion (onOpen)="accordionTabOpen()">
        <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">

            <form [formGroup]="searchForm">
                <div class="p-fluid formgrid grid">

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'Form.Header.InOutNo' | translate }}</label>
                    <p-chips formControlName="inOutNoList" [(ngModel)]="searchParams.inOutNoList" separator=","
                    (onAdd)="chipsAdd($event, 'inOutNoList')"></p-chips>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'Form.Header.SourceReferenceKey' | translate }}</label>
                    <p-chips formControlName="sourceReferenceKeyList" [(ngModel)]="searchParams.sourceReferenceKeyList" separator=","
                    (onAdd)="chipsAdd($event, 'sourceReferenceKeyList')"></p-chips>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'Form.Header.DoNo' | translate }}</label>
                    <p-chips formControlName="doNoList" [(ngModel)]="searchParams.doNoList" separator=","
                    (onAdd)="chipsAdd($event, 'doNoList')"></p-chips>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 mb-3">
                    <label>{{ 'Form.Header.Forwarder' | translate }}</label>
                    <p-dropdown formControlName="forwarder" [(ngModel)]="searchParams.forwarder" [options]="bookingForwarderOptions" [filter]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                    </p-dropdown>
                  </div>

                  <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                    <laas-calendar
                        #assignDate
                        [title]="'Form.Header.AssignDate'"
                        [enableMaxDateIsToday]="false"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        (onDateChange)="dateOnChange($event,'assignDate')">
                    </laas-calendar>
                  </div>

                </div>

                <div class="grid">
                    <div class="col">
                        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
                        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-4" (click)="resetBtn()" ></button>

                    </div>
                </div>

            </form>
        </p-accordionTab>
    </p-accordion>


    <div class="mt-2">
      <laas-data-table [expandable]="true" (rowExpanded)="searchDetailClick($event)" [selectable]="true" [(selectedRows)]="selectedInOutNo" [dataKey]="'inOutNo'" [value]="searchResults"
      [loading]="isLoading"  [defaultColumns]="columns" [tableKey]="preferenceKey"   [style]="{ 'overflow-y': 'auto' }" >

          <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
              <td *ngFor="let col of columns">
                  <ng-container [ngSwitch]="col.field">

                    <ng-container *ngSwitchCase="'inOutNo'">
                      <div class="overflow-text">
                        <a href="javascript: void(0);" (click)="linkClick($event, rowData)">{{rowData[col.field]}}</a>
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'forwarder'">
                      <div class="overflow-text">{{ rowData[col.field] | optionsMapping:bookingForwarderOptions | replaceNullWith:'-' }}</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'letterOrgId'">
                      <div class="overflow-text">{{ rowData[col.field] | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'billCorp'">
                      <div class="overflow-text">{{ rowData[col.field] | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'inOutFeeType'">
                      <div class="overflow-text">{{ rowData[col.field] | optionsMapping:inOutFeeTypeOptions | replaceNullWith:'-' }}</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'createDt'">
                      <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                    </ng-container>

                  </ng-container>
              </td>
          </ng-template>


          <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
              <laas-data-table [tableKey]="preferenceKey2"
                  [value]="rowData.inOutWarehousingDetail"
                  [defaultColumns]="detailColumns"
                  [paginator]="false" [style]="{ 'overflow-y': 'auto' }">

                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <td *ngFor="let col of columns">
                          <div [ngSwitch]="col.field">
                            <ng-container *ngSwitchCase="'createDt'">
                              <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                              <div class="overflow-text">
                                {{ rowData[col.field] | replaceNullWith:'-'}}
                              </div>
                            </ng-container>

                          </div>
                        </td>
                    </ng-template>
              </laas-data-table>
            </ng-template>
      </laas-data-table>
</div>
</p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
